import type { RecordReport } from "./recordExports";

export const RECORD_EXPORT_FORMATS = ["xlsx", "csv", "pdf", "json"] as const;
export type RecordFileFormat = (typeof RECORD_EXPORT_FORMATS)[number];

// CSV quoting does not stop formulas. Keep the guard in both download and copy output.
function quotedCell(value: string) {
  const safe = /^[\s]*[=+\-@]/u.test(value) ? `'${value}` : value;
  return `"${safe.replaceAll('"', '""')}"`;
}

export function encodeDelimitedSheet(sheet: RecordReport["sheets"][number], format: "csv" | "tsv") {
  const separator = format === "csv" ? "," : "\t";
  const lines = [sheet.headers, ...sheet.rows].map((row) => row.map(quotedCell).join(separator));
  return `${format === "csv" ? "\uFEFF" : ""}${lines.join("\r\n")}\r\n`;
}

export function encodeReportCsv(report: RecordReport) {
  const first = report.sheets[0];
  if (report.sheets.length === 1 && first) return encodeDelimitedSheet(first, "csv");
  const headers = [...new Set(report.sheets.flatMap((sheet) => sheet.headers))];
  const rows = report.sheets.flatMap((sheet) =>
    sheet.rows.map((row) => [sheet.title, ...headers.map((header) => row[sheet.headers.indexOf(header)] || "")]),
  );
  return encodeDelimitedSheet({ title: report.title, headers: ["來源表格", ...headers], rows }, "csv");
}

export function encodeReportJson(report: RecordReport) {
  return JSON.stringify(
    {
      format: "classroom-record-export",
      version: 1,
      title: report.title,
      className: report.className,
      sheets: report.sheets.map(({ title, headers, rows }) => ({ title, headers, rows })),
    },
    null,
    2,
  );
}
